import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X, Music4 } from "lucide-react";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/components/ImageUpload";

export default function AudioUpload({ value, onChange }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const resolved = resolveImageUrl(value);

  const pick = () => inputRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 16 * 1024 * 1024) {
      toast.error("El audio supera 16 MB");
      return;
    }
    try {
      setUploading(true);
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 180000 });
      onChange(data.url);
      toast.success("Audio subido");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo subir el audio");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="max-w-md">
      {resolved ? (
        <div className="glass rounded-2xl p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-warmgold/20 grid place-items-center">
              <Music4 size={18} className="text-warmgold" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-ink font-medium">Audio cargado</p>
              <p className="text-[10px] text-inksoft truncate">{resolved.split("/").pop()}</p>
            </div>
            <button onClick={pick} className="btn-ghost text-xs px-3" data-testid="music-audio-replace">
              <Upload size={12} /> Cambiar
            </button>
            <button onClick={() => onChange("")} className="btn-ghost text-xs px-2 text-red-500" data-testid="music-audio-remove">
              <X size={12} />
            </button>
          </div>
          <audio src={resolved} controls className="mt-3 w-full" data-testid="music-audio-preview">
            <track kind="captions" />
          </audio>
        </div>
      ) : (
        <button
          onClick={pick}
          disabled={uploading}
          data-testid="music-audio-upload-picker"
          className="w-full rounded-2xl border-2 border-dashed border-warmgold/30 bg-sand/50 hover:bg-sand transition-colors py-6 px-4 text-inksoft flex items-center justify-center gap-3"
        >
          {uploading ? (
            <><Loader2 className="animate-spin text-warmgold" size={20} /><span className="text-sm">Subiendo audio...</span></>
          ) : (
            <>
              <Music4 size={22} className="text-warmgold" />
              <div className="text-left">
                <p className="text-sm text-ink">Subir MP3 · M4A · OGG</p>
                <p className="text-[10px]">Autoplay garantizado · máx 16MB</p>
              </div>
            </>
          )}
        </button>
      )}
      <input ref={inputRef} type="file" accept="audio/*,.mp3,.m4a,.ogg,.wav" className="hidden" onChange={handleFile} data-testid="music-audio-upload-input" />
    </div>
  );
}
